<template>
    <svg
        :viewBox="viewbox"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path id="prefix__a" d="M0 .116h373.885V374H0z" />
        </defs>
        <g fill="none" fill-rule="evenodd">
            <mask id="prefix__b" fill="#fff">
                <use xlink:href="#prefix__a" />
            </mask>
            <path
                d="M187.235.116c132.82 0 186.65 52.66 186.65 187.235 0 133.989-52.661 186.65-186.65 186.65C52.66 374.001 0 321.34 0 187.351 0 52.776 53.83.116 187.235.116"
                fill="currentColor"
                :class="styles.box"
                mask="url(#prefix__b)"
                class="logo-box"
            />
            <path
                d="M286.118 142.297l-21.064-20.479c-5.266-5.851-11.117-5.851-16.383 0l-81.33 81.331c-5.266 5.266-14.042 5.266-19.893 0l-26.33-26.33c-5.267-5.266-11.118-5.266-16.384 0l-16.968 16.383c-5.266 5.265-5.266 11.117 0 16.383l28.671 28.67c24.574 24.575 65.532 24.575 90.106 0l79.575-79.575c5.266-5.265 5.266-11.116 0-16.383"
                fill="currentColor"
                :class="styles.checkmark"
                class="logo-checkmark"
            />
            <path
                v-if="showText"
                d="M706.226 293.84c47.394 0 77.234-22.819 77.234-60.851 0-71.383-101.808-50.319-101.808-80.745 0-9.362 8.776-15.213 22.234-15.213 10.532 0 17.553 3.511 22.819 11.703 2.925 4.095 4.681 7.606 11.117 7.606h31.011c6.436 0 11.702-4.096 9.947-11.702-5.851-30.426-33.937-47.394-75.479-47.394-44.469 0-74.894 20.479-74.894 59.096 0 70.213 101.809 50.905 101.809 81.915 0 9.362-9.362 15.798-24.575 15.798-12.287 0-21.649-4.68-25.16-14.043-2.34-5.85-4.095-8.776-11.702-8.776h-31.011c-6.436 0-11.702 4.681-9.946 12.287 5.851 32.181 35.106 50.319 78.404 50.319M854.844 289.745h42.713c7.021 0 11.702-3.511 13.457-9.948l52.66-165c2.34-7.606-1.756-12.872-8.777-12.872h-32.766c-6.436 0-11.117 2.925-12.287 10.532l-30.426 118.192h-3.51l-31.011-118.192c-1.17-7.607-5.266-10.532-12.287-10.532h-34.522c-7.021 0-11.117 5.266-8.777 12.872l52.66 165c1.756 6.437 6.437 9.948 12.873 9.948M1095.91 217.191c0 16.969-11.7 27.5-29.26 27.5-18.14 0-30.42-11.702-30.42-27.5v-43.298c0-15.213 12.28-27.5 30.42-27.5 17.56 0 29.26 11.117 29.26 28.085v42.713zm-6.44-119.947c-24.57 0-42.71 12.872-50.32 31.011h-2.92v-14.628c0-7.606-4.1-11.702-11.7-11.702h-29.26c-7.607 0-11.702 4.096-11.702 11.702V345.33c0 7.606 4.095 11.702 11.702 11.702h29.26c7.6 0 11.7-4.096 11.7-11.702v-81.915h2.92c7.61 17.553 25.75 30.425 50.32 30.425 35.11 0 59.1-24.574 59.1-60.851V158.68c0-36.862-23.99-61.436-59.1-61.436zM1187.19 289.745h29.25c7.02 0 11.12-4.681 11.12-11.702V113.627c0-7.606-4.1-11.702-11.12-11.702h-29.25c-7.61 0-11.71 4.096-11.71 11.702v164.416c0 7.021 4.1 11.702 11.71 11.702M1201.81 77.936c18.73 0 31.01-12.288 31.01-30.426 0-18.139-12.28-30.426-31.01-30.426-19.31 0-31.59 12.287-31.59 30.426 0 17.553 12.28 30.426 31.59 30.426M1353.36 70.329h8.77c7.61 0 11.71-4.096 11.71-11.702V38.148c0-7.606-4.1-11.702-11.71-11.702h-22.82c-34.52 0-57.34 21.064-57.34 53.244v22.235h-19.31c-7.6 0-11.7 4.096-11.7 11.702v23.404c0 7.607 4.1 11.703 11.7 11.703h19.31v129.309c0 7.021 4.68 11.702 11.71 11.702h29.25c7.61 0 11.7-4.681 11.7-11.702V148.734h27.5c7.61 0 11.71-4.096 11.71-11.703v-23.404c0-7.606-4.1-11.702-11.71-11.702h-27.5V89.052c0-11.702 7.02-18.723 18.73-18.723M1413.04 357.032h25.74c29.84 0 48.57-13.457 57.34-40.957l64.36-201.278c2.35-7.606-1.75-12.872-8.77-12.872h-32.77c-6.43 0-11.11 2.925-12.29 10.532l-30.42 118.192h-5.27l-31.01-118.192c-1.17-7.607-5.26-10.532-12.28-10.532h-34.53c-7.02 0-11.11 5.266-8.77 12.872l50.9 160.905c2.34 5.851 5.27 8.192 11.12 8.192h5.85l-5.85 15.798c-2.93 9.946-9.95 14.042-21.07 14.042h-12.28c-7.61 0-11.7 4.096-11.7 11.117v20.479c0 7.606 4.09 11.702 11.7 11.702M511.97 289.745h29.255c7.607 0 11.703-4.681 11.703-11.702V162.776c0-7.606 6.436-14.042 14.042-14.042h37.447c7.021 0 11.702-4.096 11.702-11.703v-23.404c0-7.606-4.681-11.702-11.702-11.702h-40.372c-35.107 0-63.777 28.67-63.777 63.777v112.341c0 7.021 4.096 11.702 11.702 11.702"
                fill="currentColor"
                :class="styles.text"
                class="logo-text"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'LogoRsvpifyFull',

    props: {
        box: {
            type: String,
            default: 'purple-logo'
        },
        checkmark: {
            type: String,
            default: 'white'
        },
        text: {
            type: String,
            default: 'violet'
        },
        showText: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        styles () {
            return {
                box: `text-${this.box}`,
                checkmark: `text-${this.checkmark}`,
                text: `text-${this.text}`
            };
        },

        viewbox () {
            if (this.showText) {
                return `0 0 1601 374`;
            }

            return `0 0 374 374`;
        }
    }
};
</script>
